import { Svg } from 'components/svg/Svg';

import s from './BackButton.module.scss';

type Props = {
  onClick?: () => void;
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const BackButton = (props: Props) => {
  const { children } = props;
  return (
    <button {...props} className={s.backButton}>
      <Svg id="arrowleft" />
      <span>{children}</span>
    </button>
  );
};
